import React from "react";
import {
  Container,
  Header,
  Form,
  Button,
  Message,
  Segment
} from "semantic-ui-react";

const FindPassword = ({
  step,
  mbrId,
  code,
  newPassword,
  newPasswordConfirm,
  onChangeMbrId,
  onChangeCode,
  onChangeNewPassword,
  onChangeNewPasswordConfirm,
  onSendCode,
  onResetPassword,
  onClickCancel,
  isSending,
  isResetting,
  errorMessage,
  successMessage
}) => {
  return (
    <Container style={{ paddingTop: "5em", maxWidth: 480 }}>
      <Header as="h2">비밀번호 찾기</Header>

      {errorMessage ? (
        <Message negative>
          <p>{errorMessage}</p>
        </Message>
      ) : null}
      {successMessage ? (
        <Message positive>
          <p>{successMessage}</p>
        </Message>
      ) : null}

      <Segment>
        {step === "sendCode" ? (
          <Form>
            <p>가입 시 사용한 회사 메일(@dayside.co.kr)로 인증코드를 보내드립니다.</p>
            <Form.Field>
              <label>아이디 (mbrId)</label>
              <input
                value={mbrId}
                onChange={onChangeMbrId}
                placeholder="예: hong"
                autoFocus
              />
            </Form.Field>
            <Button
              primary
              onClick={onSendCode}
              disabled={!mbrId || isSending}
              loading={isSending}
            >
              인증코드 받기
            </Button>
            <Button type="button" onClick={onClickCancel}>
              취소
            </Button>
          </Form>
        ) : (
          <Form>
            <p>
              <b>{mbrId}@dayside.co.kr</b> 로 발송한 인증코드와 새 비밀번호를 입력해주세요.
              (10분 안에 입력)
            </p>
            <Form.Field>
              <label>인증코드 (6자리)</label>
              <input
                value={code}
                onChange={onChangeCode}
                placeholder="123456"
                maxLength={6}
                autoFocus
              />
            </Form.Field>
            <Form.Field>
              <label>새 비밀번호</label>
              <input
                type="password"
                value={newPassword}
                onChange={onChangeNewPassword}
                placeholder="영문/숫자/특수문자 포함 8~15자"
              />
            </Form.Field>
            <Form.Field>
              <label>새 비밀번호 확인</label>
              <input
                type="password"
                value={newPasswordConfirm}
                onChange={onChangeNewPasswordConfirm}
              />
            </Form.Field>
            <Button
              primary
              onClick={onResetPassword}
              disabled={!code || !newPassword || !newPasswordConfirm || isResetting}
              loading={isResetting}
            >
              비밀번호 변경
            </Button>
            <Button type="button" onClick={onClickCancel}>
              취소
            </Button>
          </Form>
        )}
      </Segment>
    </Container>
  );
};

export default FindPassword;
